import { Mail, MessageCircle, Phone } from 'lucide-react';

const ContactBanner = ({ whatsappNumber = null }) => {
  // Format WhatsApp link - remove spaces and ensure country code
  const getWhatsAppLink = () => {
    if (!whatsappNumber) return null;
    const cleanNumber = whatsappNumber.replace(/\s/g, '').replace('+', '');
    return `https://wa.me/${cleanNumber}?text=Hi%20JustDive!%20I%20have%20a%20question.`;
  };

  const whatsappLink = getWhatsAppLink();

  return (
    <div className="bg-gradient-to-r from-[#0A2342] to-[#0A2342]/90 rounded-xl p-6 md:p-8 text-white">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <h3 className="text-xl md:text-2xl font-heading font-bold mb-2">
            Have Questions?
          </h3>
          <p className="text-gray-300 text-sm md:text-base">
            We're here to help! Reach out to us for any enquiries about trips, courses, or gear.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3">
          {/* Email Button */}
          <a
            href="mailto:info@justdive.co.za"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-[#0A2342] rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <Mail className="w-5 h-5" />
            <span>info@justdive.co.za</span>
          </a>
          
          {/* WhatsApp Button - Only show if number is provided */}
          {whatsappLink && (
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#25D366] text-white rounded-lg font-semibold hover:bg-[#20BD5A] transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp Us</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactBanner;
